"use strict";

// https://infra.spec.whatwg.org/#parse-json-from-bytes
exports.parseJSONFromBytes = bytes => {
  const jsonText = bytes.toString("utf-8");

  return JSON.parse(jsonText);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdom/lib/jsdom/living/helpers/json.js
// module id = mmcg
// module chunks = 0